import ContentLoader from "react-content-loader";


const MyExplorationPopoverLoader = () => (
  <ContentLoader
    speed={2}
    width={245}
    height={435}
    viewBox="0 0 245 435"
    backgroundColor="rgba(151, 161, 157, 0.15)"
    foregroundColor="rgba(151, 161, 157, 0.2)"
  >
    <rect x="0" y="30" rx="6" ry="6" width="244" height="18"/>

    <rect x="0" y="102" rx="6" ry="6" width="210" height="12"/>
    <rect x="0" y="136" rx="6" ry="6" width="180" height="12"/>

    <rect x="0" y="170" rx="6" ry="6" width="210" height="12"/>
    <rect x="0" y="204" rx="6" ry="6" width="180" height="12"/>

    <rect x="0" y="238" rx="6" ry="6" width="210" height="12"/>
    <rect x="0" y="272" rx="6" ry="6" width="180" height="12"/>

    <rect x="0" y="306" rx="6" ry="6" width="210" height="12"/>
    <rect x="0" y="340" rx="6" ry="6" width="180" height="12"/>

    <rect x="0" y="376" rx="6" ry="6" width="210" height="12"/>
    <rect x="0" y="410" rx="6" ry="6" width="180" height="12"/>

  </ContentLoader>
)

export default MyExplorationPopoverLoader;